// TechnoArt 2025 logo for Galaxy ALPR
import React from "react";

const TechnoArtLogo: React.FC = () => (
  <div
    style={{
      position: "fixed",
      right: 24,
      bottom: 24,
      zIndex: 50,
      pointerEvents: "none",
      userSelect: "none",
    }}
  >
    <img
      src="/assets/logo-techno-art-2025.png"
      alt="TechnoArt 2025 Logo"
      style={{ width: 180, height: "auto", opacity: 0.92 }}
      draggable={false}
    />
  </div>
);

export default TechnoArtLogo;
